import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Spinner as BsSpinner } from 'react-bootstrap';
import { colors, spacing, typography } from '../tokens';

// Spinner — wrap Bootstrap Spinner với 2 chế độ:
//   - Standalone: <Spinner size='md' /> → spinner đơn lẻ
//   - Block (page-level): <Spinner block label='Đang tải...' /> →
//     spinner + label căn giữa, dùng cho trạng thái loading full-page
//     hoặc trong card.
const SIZE_PX = { xs: 14, sm: 18, md: 24, lg: 36 };

function Spinner({ size = 'sm', label, block = false, variant = 'primary' }) {
  if (block) {
    return (
      <Block>
        <StyledSpinner $px={SIZE_PX[size]} $color={variant === 'primary' ? colors.primary : colors.gray500} />
        {label && <Label>{label}</Label>}
      </Block>
    );
  }
  return (
    <StyledSpinner $px={SIZE_PX[size]} $color={variant === 'primary' ? colors.primary : colors.gray500} />
  );
}

// react-bootstrap Spinner đã sẵn sàng — chỉ override size/color qua
// styled-components.
const StyledSpinner = styled(BsSpinner).attrs({ animation: 'border', role: 'status' })`
  width: ${(p) => p.$px}px;
  height: ${(p) => p.$px}px;
  border-width: ${(p) => Math.max(2, Math.round(p.$px / 8))}px;
  color: ${(p) => p.$color};
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing[3]};
  padding: ${spacing[8]} 0;
`;

const Label = styled.div`
  font-size: ${typography.size.sm};
  color: ${colors.gray500};
`;

export default Spinner;
